export const wrapper = 'h-full bg-white';
export const bannerContentWrapper =
  'flex flex-col justify-between items-stretch';
export const listItems = 'list-disc ml-6';
export const spaceTop = 'mt-4';
export const closeButton = 'mt-4 mb-4 w-full';
